import { render, staticRenderFns } from "./LoanTypeDetailsPage.vue?vue&type=template&id=a2529db4&scoped=true"
import script from "./LoanTypeDetailsPage.vue?vue&type=script&lang=js"
export * from "./LoanTypeDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./LoanTypeDetailsPage.vue?vue&type=style&index=0&id=a2529db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2529db4",
  null
  
)

export default component.exports